import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Dropdown from "react-dropdown";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";

import { baseURL } from "../../constants/pathnames";
import Body from "../Home/Body";
import Input from "../Input/Input";
import Button from "../Button/Button";
import { arrow_down, arrow_up } from "../../constants/data";
import {
  moblieNumber,
  mobileChecker,
  regularPhoneNumber,
} from "../../constants/services";

export default function CreateUser() {
  const { token } = useSelector((state) => state.users);
  const history = useHistory();
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const [loader, setLoader] = useState(false);

  const [isSuperuser, setIsSuperuser] = useState("false");
  const [isSuperuserError, setIsSuperuserError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [passwordConfirmationError, setPasswordConfirmationError] =
    useState("");

  const [name, setname] = useState("");
  const [nameError, setnameError] = useState("");

  const [lastname, setlastname] = useState("");
  const [lastnameError, setlastnameError] = useState("");

  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const onSubmitHandler = () => {
    if (!name) {
      setnameError("ضروری");
    }
    if (!lastname) {
      setlastnameError("ضروری");
    }
    if (!username) {
      setUsernameError("ضروری");
    }
    if (!phone) {
      setPhoneNumberError("ضروری");
    }
    if (!email) {
      setEmailError("ضروری");
    }
    if (!password) {
      setPasswordError("ضروری");
    }
    if (!passwordConfirmation) {
      setPasswordConfirmationError("ضروری");
    }
    if (password !== passwordConfirmation) {
      setPasswordConfirmationError("با کلمه عبور یکسان نیست.");
    }
    if (
      !name ||
      !lastname ||
      !username ||
      !phone ||
      !email ||
      !password ||
      !passwordConfirmation ||
      password !== passwordConfirmation
    ) {
      return;
    }

    const formData = {
      password: password,
      last_login: null,
      is_superuser: Boolean(isSuperuser),
      username: username,
      first_name: name,
      last_name: lastname,
      email,
      phone_number: regularPhoneNumber(phone),
      is_staff: false,
      is_active: true,
      verify_codes: "49136",
      settings: {},
      balance: 0,
      last_message_received_at: null,
      groups: [],
      user_permissions: [],
    };

    setLoader(true);
    axios
      .post(`${baseURL}panel/users/`, formData, header)
      .then((res) => {
        setLoader(false);
        toast.success("کاربر با موفقیت ساخته شد.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        history.goBack();
      })
      .catch((err) => {
        setLoader(false);
        toast.error("یک یا چند خطا رخ داد.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <Body state={1}>
      <div className="flex justify-between items-center gap-3 h-16 mb-10">
        {/* back arrow */}
        <div className="flex justify-start items-center font-semibold gap-4 py-4">
          <img
            className="cursor-pointer"
            src="/statics/images/arrow-right-black1.svg"
            width="16px"
            height="16px"
            alt="arrow"
            onClick={() => {
              history.goBack();
            }}
          />
          <span>ایجاد کاربر جدید</span>
        </div>

        <div className="m-1 py-2 px-2 rounded-lg shadow cursor-pointer h-8 w-8">
          <img
            className="mx-auto "
            src="/statics/images/bell.svg"
            width="16"
            height="16"
            alt="bell"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-5 w-2/3">
        <Input
          title="نام"
          placeholder=""
          maxWidth="100%"
          value={name}
          error={nameError}
          type="text"
          input
          onChange={(event) => {
            let { value } = event.target;
            setname(value);
            setnameError("");
          }}
          margin={"0"}
        />
        <Input
          title="نام خانوادگی"
          placeholder=""
          maxWidth="100%"
          value={lastname}
          error={lastnameError}
          type="text"
          input
          onChange={(event) => {
            let { value } = event.target;
            setlastname(value);
            setlastnameError("");
          }}
          margin={"0"}
        />
        <Input
          title="نام کاربری"
          placeholder=""
          maxWidth="100%"
          value={username}
          error={usernameError}
          type="text"
          input
          onChange={(event) => {
            let { value } = event.target;
            setUsername(value);
            setUsernameError("");
          }}
          margin={"0"}
        />
        <Input
          title="شماره همراه"
          placeholder=""
          maxWidth="100%"
          value={phone}
          error={phoneNumberError}
          type="text"
          input
          onChange={(event) => {
            let { value } = event.target;
            setPhone(value);
            setPhoneNumberError("");
          }}
          margin={"0"}
        />
        <Input
          title="ایمیل"
          placeholder=""
          maxWidth="100%"
          value={email}
          error={emailError}
          type="text"
          input
          onChange={(event) => {
            let { value } = event.target;
            setEmail(value);
            setEmailError("");
          }}
          margin={"0"}
        />
        <div>
          <div className="font-semibold my-1">
            آیا ادمین پنل باشد؟
            {/* <span className='color-red px-1'>*</span> */}
          </div>
          <div className="w-full">
            <div className="relative">
              <Dropdown
                id={0}
                className="w-full rounded-lg shadow-md border-gray-300 border dropdown"
                controlClassName="py-2 flex justify-between w-full "
                menuClassName=""
                arrowClosed={arrow_down}
                arrowOpen={arrow_up}
                options={[
                  { label: "بله", value: "true" },
                  { label: "خیر", value: "false" },
                ]}
                onChange={(val) => {
                  setIsSuperuser(val);
                  setIsSuperuserError("");
                }}
                value={isSuperuser}
                placeholder={"انتخاب کنید"}
              />
            </div>
          </div>
        </div>
        <Input
          title="کلمه عبور"
          placeholder=""
          maxWidth="100%"
          value={password}
          error={passwordError}
          type="password"
          input
          onChange={(event) => {
            let { value } = event.target;
            setPassword(value);
            setPasswordError("");
          }}
          margin={"0"}
        />
        <Input
          title="تکرار کلمه عبور"
          placeholder=""
          maxWidth="100%"
          value={passwordConfirmation}
          error={passwordConfirmationError}
          type="password"
          input
          onChange={(event) => {
            let { value } = event.target;
            setPasswordConfirmation(value);
            setPasswordConfirmationError("");
          }}
          margin={"0"}
        />
      </div>
      <div className="w-2/3 flex justify-end items-center mt-8">
        <Button
          title="ایجاد کاربر جدید"
          backgroundColor="green"
          color="#fff"
          borderColor="green"
          borderWidth="2px"
          margin="0"
          maxWidth="120px"
          fontSize="12px"
          maxHeight="40px"
          onClick={onSubmitHandler}
          loading={loader}
        />
      </div>
    </Body>
  );
}
